import { createEvent, createStore, restore, sample } from "effector";
import { ModelContract, ModuleDescription } from "@features/shared/module-description";

export const appMounted = createEvent();
export const routePathNameChanged = createEvent<string>();
export const routeParamsChanged = createEvent<Record<string, string | string[]>>();
export const routeStateChanged = createEvent<{
    path: string;
    params: Record<string, string | string[]>;
    search: string;
}>();
export const onboardingProgressUpdated = createEvent<number>();
// i18next's current UI language (Language code), emitted from Providers on mount and on every change.
export const appLanguageChanged = createEvent<string>();
export const $appLanguage = restore(appLanguageChanged, "en");
export const $activeRoute = restore(routePathNameChanged, "/");
export const $routeParams = restore(routeParamsChanged, {});

export const $isOnboarding = createStore<boolean>(false);
export const $onboardingProgress = createStore<number>(0);

sample({
    clock: routePathNameChanged,
    fn: (url: string) => {
        const result =
            url === "/" ||
            url === "/payment" ||
            url.startsWith("/onboarding/") ||
            url === "/onboarding" ||
            url === "/auth/signin" ||
            url === "/creator";
        return result;
    },
    target: [$isOnboarding]
});

const contract = new ModelContract(
    {
        $isOnboarding,
        $onboardingProgress,
        $activeRoute,
        $routeParams
    },
    {
        appMounted,
        onboardingProgressUpdated,
        routePathNameChanged,
        routeParamsChanged,
        routeStateChanged
    },
    {},
    {}
);

export type IAppContract = typeof contract;

export class AppModule extends ModuleDescription<IAppContract> {
    getDefaultContract() {
        return contract;
    }
}
